<template>
    <div class="w-full h-full cursor-pointer" v-on-clickaway="close">
        <div @click="open()" class="w-full h-full flex items-center justify-center">
            <slot name="icon" />
        </div>

        <div class="absolute inset-0 bg-gray-1000 z-20" :class="{ 'opacity-0 pointer-events-none': !isOpen }">
            <div class="absolute inset-0 cursor-pointer"
                style="transition: right 0.3s ease-out"
                :style="{ 'right': isOpen ? '0' : '100%' }"
            >
                <slot name="content" :close="close" :isOpen="isOpen" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mixin as clickaway } from 'vue-clickaway'

    export default {
        mixins: [clickaway],

        data() {
            return {
                isOpen: false,
                openWidth: 0,
            }
        },

        methods: {
            open() {
                this.isOpen = true
            },

            close() {
                this.isOpen = false
            },
        },
    }
</script>